import { useContext, useEffect, useState } from "react";

import { saveUserRound, resetEnergyLevel } from "../../api/gameService";

import { useParams } from "react-router-dom";

import swingingOom from "../../assets/images/Group 146swingingOom.png";
import speaker from "../../assets/images/speaker.png";
import squirrel from "../../assets/images/squirrel.png";
import AnimatedImage from "../../components/AnimatedImage/AnimatedImage";
import ButtonRound from "../../components/ButtonRound/ButtonRound";
import ButtonRoundContainer from "../../components/ButtonRoundContainer/ButtonRoundContainer";
import GameEnd from "../../components/GameEnd/GameEnd";
import Layout from "../../components/Layout/Layout";
import NeedsContainer from "../../components/NeedsContainer/NeedsContainer";
import PhonicComponent from "../../components/PhonicComponent/PhonicComponent";
import Timer from "../../components/Timer/Timer";
import UserContext from "../../context/UserContext";
import phonics from "../../data/phonicsData";
import {
  getArrayForGame,
  updateUserStats,
  getLevelData,
} from "../../utils/gameUtils";
import "./SwingGame.scss";

const SwingGamePage = () => {
  const { level } = useParams();
  const currentLevel = getLevelData(level);

  const [gameState, setGameState] = useState({
    score: 0,
    index: 0,
    isCorrect: false,
  });
  const [hintAnimation, setHintAnimation] = useState("");
  const [oomAnimation, setOomAnimation] = useState("");
  const [phonicsArray, setPhonicsArray] = useState([]);
  const [isGameOver, setIsGameOver] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [indexesUsed, setIndexesUsed] = useState([0]);

  const { user, getRounds, setUser } = useContext(UserContext);

  // adds animate class to squirrel, removes after 3 seconds
  const triggerHintAnimation = () => {
    setHintAnimation("animate__bounce");
    setInterval(() => {
      setHintAnimation("");
    }, 3000);
  };

  // load up the phonics array
  useEffect(async () => {
    if (!user?.uid) return;
    const array = await getArrayForGame(
      parseInt(level),
      "swing",
      getRounds("swing", false),
      getRounds("swing", true),
      15
    );
    setPhonicsArray(array);
    setIsLoaded(true);
  }, [user?.uid]);

  // adds animate class to oom, removes after 8 seconds
  const triggerOomAnimation = () => {
    setOomAnimation("animate__swinging");
    setInterval(() => {
      setOomAnimation("");
    }, 8000);
  };

  const handleAnswer = async (isCorrect) => {
    setHintAnimation(false);
    if (isCorrect) {
      triggerOomAnimation();
      updateUserStats("fuel", user, setUser);
    }
    const currentPhonic = phonicsArray[gameState.index];
    const score = gameState.score + (isCorrect ? 1 : 0);
    const index = handleIndexChange();

    setGameState({
      score,
      isCorrect,
      index,
    });

    try {
      await saveUserRound(
        user.uid,
        "swing",
        1,
        { isCorrect, score },
        currentPhonic
      );
      console.log(`Saved user round - ${isCorrect ? "" : "in"}correct!`);
    } catch (e) {
      console.error("Error attempting to save a user's round", e);
    }
  };

  // TODO: stop sound playing multiple times
  const handleHint = async () => {
    const currentPhonic = phonicsArray[gameState.index];
    const phonicSound = await phonics[currentLevel][currentPhonic].sound();
    new Audio(phonicSound).play();

    triggerHintAnimation();
  };

  // Handle index change while progressing through swing game
  const handleIndexChange = () => {
    //generate random number within length of phonics array
    let newRandomIndex = Math.floor(Math.random() * phonicsArray.length);
    //if indexes used includes the number, generate another one
    while (indexesUsed.includes(newRandomIndex)) {
      newRandomIndex = Math.floor(Math.random() * phonicsArray.length);
    }

    setIndexesUsed((currState) => {
      const tempIndexes = [...currState];
      //push the random number to the indexes used array
      tempIndexes.push(newRandomIndex);
      //clear the indexUsed array once it reaches the length of the phonics array
      if (tempIndexes.length == phonicsArray.length) {
        return [];
      }
      return tempIndexes;
    });

    return newRandomIndex;
  };

  const handleGameEnd = () => {
    setIsGameOver(true);
  };

  if (!isLoaded) {
    return (
      <Layout requiresAuth={true}>
        <div className="swing-game">
          <p>Loading...</p>
        </div>
      </Layout>
    );
  }

  if (isGameOver) {
    return (
      <Layout requiresAuth={true}>
        <div className="swing-game">
          <GameEnd
            score={gameState.score}
            childName={user.childName}
            energyLevel={user.energyLevel}
            gameType={"Swing Game"}
          />
        </div>
      </Layout>
    );
  }

  const lastPlayed = user.roundsPlayed[user.roundsPlayed.length - 1];
  const lastPlayedDate = new Date(lastPlayed?.roundTime.seconds * 1000);
  const lastPlayedDay = lastPlayedDate.getDate();

  if (lastPlayed !== undefined) {
    if (new Date().getDate() !== lastPlayedDay) {
      try {
        resetEnergyLevel(user.uid);
      } catch (e) {
        console.log("error updating energy level");
      }
    }
  }

  if (user.energyLevel == 0) {
    return (
      <Layout requiresAuth={true}>
        <div className="swing-game">
          <GameEnd
            score={gameState.score}
            childName={user.childName}
            energyLevel={user.energyLevel}
          />
        </div>
      </Layout>
    );
  }

  return (
    <Layout requiresAuth={true}>
      <div className="swing-game">
        <NeedsContainer />
        <div className="swing-game__phonic">
          <Timer
            startTime={60}
            onTimeUp={handleGameEnd}
            onSixSecondIncrement={(level) =>
              updateUserStats(level, user, setUser)
            }
          />
          <PhonicComponent phonicText={phonicsArray[gameState.index]} />
        </div>
        <div onClick={handleHint}>
          <AnimatedImage
            imageToAnimate={squirrel}
            animationClass="animate__animated.animate__fastest"
            animationType={hintAnimation}
            imageStylesClass="swing-game__squirrel"
          />
        </div>
        <AnimatedImage
          imageToAnimate={swingingOom}
          animationClass="animate__animated.animate__fastest"
          animationType={oomAnimation}
          imageStylesClass="swing-game__oom"
        />
        <ButtonRoundContainer
          handleCorrect={() => handleAnswer(true)}
          handleIncorrect={() => handleAnswer(false)}
        />
        <ButtonRound
          onClick={handleHint}
          backgroundColor="#0d6efd"
          iconImg={speaker}
          alt="speaker"
          backgroundColorHover="#2d81ff"
          isLeft="true"
        />
        <p className="swing-game__score">
          Number Of Correct Sounds: {gameState.score}
        </p>
      </div>
    </Layout>
  );
};

export default SwingGamePage;
